import script from "./FlatSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./FlatSpinner.vue?vue&type=style&index=0&id=1d2f4024&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2f4024"]])

export default __exports__